import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import $ from 'jquery';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { TimersService } from '@_services/timers.service';
import { BehaviorService } from '@_services/Behavior.service';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-searchandreplaceworkitem',
  templateUrl: './searchandreplaceworkitem.component.html',
  styleUrls: ['./searchandreplaceworkitem.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SearchandreplaceworkitemComponent implements OnInit, OnDestroy {
  isspiner = false;
  searchTerm = '';
  replaceTerm = '';
  private _unsubscribeAll$: Subject<void> = new Subject();
  confirmDialogRef: MatDialogRef<any>;
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;

  addData: any = [];
  TemplateName: any;
  getSelectedWIP: any;
  getSelectedWIPNewPrice: any = [];
  IsWipData: boolean = false;
  isLoadingResults: boolean = true;
  successMsg: any = 'Time entry Updated Successfully';
  workItem: any;
  workItemUpdatedText = '';
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  FeeErner = this.currentUser.WORKINGONBEHALFOFGUID
    ? this.currentUser.WORKINGONBEHALFOFGUID
    : this.currentUser.UserId;
  listofUnbuildtimeEntry = [];
  showStartCancel: boolean;
  CurrentAdditionalText: any;
  UpdatedAdditionalext: any;
  readonly: boolean;
  Apicount = 0;
  filterData: any[];
  isSkip: boolean = false;
  matchCase = false;
  wholeWord = false;
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private timersService: TimersService,
    private toastr: ToastrService,
    public MatDialog: MatDialog,
    private cd: ChangeDetectorRef,
    public dialogRef: MatDialogRef<SearchandreplaceworkitemComponent>,
    private behaviourService: BehaviorService,
    private router: Router,
  ) {
    if (this.router.url == '/invoice/bulk-invoices') {
      this.showStartCancel = true;
    } else {
      // this.showStartCancel=false;
      this.showStartCancel = true;
    }
    this.behaviourService.defultFeeErnerData$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((result) => {
        if (result) {
          this.FeeErner = result;
        }
      });
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviourService.workInProgress$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((result) => {
        if (result) {
          this.getSelectedWIP = result;
        }
      });

    this.loadData();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  skipFindReplace() {
    if (this.searchTerm.trim() == '' || this.searchTerm.trim() == ' ') {
      this.toastr.error('Search Term is Required.');
      return;
    }

    // let pattern = this.searchTerm;
    // if (this.wholeWord) {
    //     pattern = `\\b${pattern}\\b`;
    // }
    // const flags = this.matchCase ? '' : 'i';
    // const regex = new RegExp(pattern, flags);
    // const regex = this.buildRegex(this.searchTerm.trim(), this.matchCase, this.wholeWord);
    // if(this.Apicount == 0){
    //     console.log('hererre iffff 104')
    //     console.log('this.listofUnbuildtimeEntry',this.listofUnbuildtimeEntry);
    //     // this.filterData = this.listofUnbuildtimeEntry.filter((unbuildData) => {
    //     //     return unbuildData.ADDITIONALTEXT.trim().toLowerCase().indexOf(this.searchTerm.trim().toLowerCase()) > -1 && (unbuildData.ITEMTYPEDESC == 'WIP' || unbuildData.ITEMTYPEDESC == 'Activity' || unbuildData.ITEMTYPEDESC == 'Sundry');
    //     // });
    //     this.filterData = this.listofUnbuildtimeEntry.filter((unbuildData) => {
    //         const text = this.matchCase ? unbuildData.ADDITIONALTEXT.trim() : unbuildData.ADDITIONALTEXT.trim().toLowerCase();
    //         return regex.test(text) &&
    //         (unbuildData.ITEMTYPEDESC === 'WIP' ||
    //             unbuildData.ITEMTYPEDESC === 'Activity' ||
    //             unbuildData.ITEMTYPEDESC === 'Sundry');
    //     });
    //     console.log(this.filterData,this.filterData.length);
    // } else {
    //     if(this.matchCase || this.wholeWord) {
    //         console.log('hererre else 117')
    //         console.log('this.listofUnbuildtimeEntry',this.listofUnbuildtimeEntry);
    //         this.filterData = this.listofUnbuildtimeEntry.filter((unbuildData) => {
    //             const text = this.matchCase ? unbuildData.ADDITIONALTEXT.trim() : unbuildData.ADDITIONALTEXT.trim().toLowerCase();
    //             return regex.test(text) &&
    //             (unbuildData.ITEMTYPEDESC === 'WIP' ||
    //                 unbuildData.ITEMTYPEDESC === 'Activity' ||
    //                 unbuildData.ITEMTYPEDESC === 'Sundry');
    //         });
    //         console.log(this.filterData,this.filterData.length);
    //     }
    // }
    // return this.listofUnbuildtimeEntry.filter((entry) => {
    //     const text = this.matchCase ? entry.ADDITIONALTEXT.trim() : entry.ADDITIONALTEXT.trim().toLowerCase();
    //     return regex.test(text) && ['WIP', 'Activity', 'Sundry'].includes(entry.ITEMTYPEDESC);
    // });
    this.filterData = this.getFilteredData();
    if (this.filterData.length == 0) {
      this.toastr.error('There are no time entries/fixed fees available for search and replace!');
      return;
    }

    // let re = new RegExp(`${this.searchTerm.trim().toLowerCase()}`, 'gi');
    // let re = new RegExp(`${this.searchTerm.trim().toLowerCase()}`, 'gi');
    let re = this.buildRegex(this.searchTerm.trim(), this.matchCase, this.wholeWord);
    if (this.isSkip == true) {
      this.Apicount++;
      if (this.Apicount <= this.filterData.length - 1) {
        this.CurrentAdditionalText =
          this.filterData.length - 1 >= this.Apicount
            ? this.filterData[this.Apicount].ADDITIONALTEXT
            : this.UpdateDataValue();
        this.UpdatedAdditionalext =
          this.filterData.length - 1 >= this.Apicount
            ? this.filterData[this.Apicount].ADDITIONALTEXT.replace(re, this.replaceTerm)
            : this.UpdateDataValue();
      } else {
        this.UpdateDataValue();
      }
    }
    this.isSkip = false;
  }

  /**
   * This function is used to replaceterm To UnbilledTime Entry.
   */
  async replaceTermToUnbilledTimeEntries() {
    // if(this.router.url =="/invoice/bulk-invoices"){
    if (this.searchTerm.trim() == '' || this.searchTerm.trim() == ' ') {
      this.toastr.error('Search Term is Required.');
      return;
    }
    // let pattern = this.searchTerm;
    // if (this.wholeWord) {
    //     pattern = `\\b${pattern}\\b`;
    // }
    // const flags = this.matchCase ? '' : 'i';
    // const regex = new RegExp(pattern, flags);
    // const regex = this.buildRegex(this.searchTerm.trim(), this.matchCase, this.wholeWord);
    // if(this.Apicount == 0){
    //     console.log('hererre iffff 151')
    //     // this.filterData = this.listofUnbuildtimeEntry.filter((unbuildData) => {
    //     //     return unbuildData.ADDITIONALTEXT.trim().toLowerCase().indexOf(this.searchTerm.trim().toLowerCase()) > -1 && (unbuildData.ITEMTYPEDESC == 'WIP' || unbuildData.ITEMTYPEDESC == 'Activity' || unbuildData.ITEMTYPEDESC == 'Sundry');
    //     // });
    //     console.log('this.listofUnbuildtimeEntry',this.listofUnbuildtimeEntry);
    //     this.filterData = this.listofUnbuildtimeEntry.filter((unbuildData) => {
    //         const text = this.matchCase ? unbuildData.ADDITIONALTEXT.trim() : unbuildData.ADDITIONALTEXT.trim().toLowerCase();
    //         return regex.test(text) &&
    //         (unbuildData.ITEMTYPEDESC === 'WIP' ||
    //             unbuildData.ITEMTYPEDESC === 'Activity' ||
    //             unbuildData.ITEMTYPEDESC === 'Sundry');
    //     });
    //     console.log(this.filterData,this.filterData.length);
    // } else {
    //     if(this.matchCase || this.wholeWord) {
    //         console.log('hererre elseee 177')
    //         console.log('this.listofUnbuildtimeEntry',this.listofUnbuildtimeEntry);
    //         this.filterData = this.listofUnbuildtimeEntry.filter((unbuildData) => {
    //             const text = this.matchCase ? unbuildData.ADDITIONALTEXT.trim() : unbuildData.ADDITIONALTEXT.trim().toLowerCase();
    //             return regex.test(text) &&
    //             (unbuildData.ITEMTYPEDESC === 'WIP' ||
    //                 unbuildData.ITEMTYPEDESC === 'Activity' ||
    //                 unbuildData.ITEMTYPEDESC === 'Sundry');
    //         });
    //         console.log(this.filterData,this.filterData.length);
    //     }
    // }
    // this.filterData = this.getFilteredData();
    this.filterData = cloneDeep(this.getFilteredData());
    if (this.filterData.length == 0) {
      this.toastr.error('There are no time entries/fixed fees available for search and replace!');
      return;
    }
    // let re = new RegExp(`${this.searchTerm.trim().toLowerCase()}`, 'gi');
    // let re = new RegExp(`${this.searchTerm.trim().toLowerCase()}`, 'gi');
    // let re = new RegExp(`\\b${this.searchTerm.trim().toLowerCase()}\\b`, 'gi');
    let re = this.buildRegex(this.searchTerm.trim(), this.matchCase, this.wholeWord);
    if (this.Apicount <= this.filterData.length - 1) {
      this.workItem = this.filterData[this.Apicount];
      this.isspiner = true;
      await this.ChangePrice().then(async () => {
        // This is for increase the API Call by one
        this.Apicount += this.filterData.length == 1 ? 0 : 1;
        this.CurrentAdditionalText =
          this.filterData.length - 1 >= this.Apicount
            ? this.filterData[this.Apicount].ADDITIONALTEXT
            : this.UpdateDataValue();
        this.UpdatedAdditionalext =
          this.filterData.length - 1 >= this.Apicount
            ? this.filterData[this.Apicount].ADDITIONALTEXT.replace(re, this.replaceTerm)
            : this.UpdateDataValue();
        if (this.filterData.length == 1) {
          this.UpdateDataValue();
        }
      });
    } else {
      this.UpdateDataValue();
    }
    // }
    // else {
    //     let finalLoadUnbuildTimeEntryList: any = [];
    // if (this.searchTerm.trim() == "" || this.searchTerm.trim() == " ") {
    //     this.toastr.error("Search Term is Required.");
    //     return;
    // };

    // let filterData = this.listofUnbuildtimeEntry.filter((unbuildData) => {
    //     return unbuildData.ADDITIONALTEXT.trim().toLowerCase().indexOf(this.searchTerm.trim().toLowerCase()) > -1 && (unbuildData.ITEMTYPEDESC == 'WIP' || unbuildData.ITEMTYPEDESC == 'Activity' || unbuildData.ITEMTYPEDESC == 'Sundry');
    // })
    // if (filterData.length == 0) {
    //     this.toastr.error("There are no time entries/fixed fees available for search and replace!");
    //     return;
    // }
    //     // let re = new RegExp(`\\b${this.searchTerm.trim().toLowerCase()}\\b`, 'gi');
    //     let re = new RegExp(`${this.searchTerm.trim().toLowerCase()}`, 'gi');
    //     for (let i = 0; i < filterData.length; i++) {
    //         await new Promise(async (next, reject) => {
    //             this.workItem = await filterData[i];
    //             this.confirmDialogRef = await this.MatDialog.open(FuseConfirmDialogComponent, {
    //                 disableClose: true,
    //                 width: DIALOG_WIDTH.FULL,
    //             });

    //             this.confirmDialogRef.componentInstance.confirmMessage = `Are you sure you want to change "${filterData[i].ADDITIONALTEXT}"  to  "${filterData[i].ADDITIONALTEXT.replace(re, this.replaceTerm)}"?`;

    //             await this.confirmDialogRef.afterClosed().subscribe(async result => {
    //                 if (result) {
    //                     this.isspiner = true;
    //                     this.workItemUpdatedText = filterData[i].ADDITIONALTEXT.replace(re, this.replaceTerm);
    //                     this.UpdatedAdditionalext=this.workItemUpdatedText;
    //                     await this.ChangePrice().then(() => {
    //                         finalLoadUnbuildTimeEntryList.push(true);
    //                         next(true);
    //                     })
    //                 } else {
    //                     this.workItemUpdatedText = '';
    //                     finalLoadUnbuildTimeEntryList.push(false)
    //                     next(false);
    //                 }
    //                 this.confirmDialogRef = null;
    //             });
    //         });
    //     };

    // await Promise.all([finalLoadUnbuildTimeEntryList]).then((dataResponse) => {
    //     this.dialogRef.close(true);
    //     $('#refreshWorkInprogress').click();
    //     if(this.router.url=="/invoice/bulk-invoices"){
    //         $("#refreshtabledetails").click();
    //     }
    // });
    // }
  }

  /**
   * This function is used to change the Price
   */
  ChangePrice() {
    return new Promise((next, rej) => {
      this.isspiner = true;
      if (!this.showStartCancel) {
        this.workItem.ADDITIONALTEXT = this.UpdatedAdditionalext;
      } else if (this.workItemUpdatedText !== '') {
        this.workItem.ADDITIONALTEXT = this.workItemUpdatedText;
      }

      // let PostData: any = this.workItem;
      let PostData: any;
      PostData = {
        ADDITIONALTEXT: this.workItem.ADDITIONALTEXT,
        WORKITEMGUID: this.workItem.WORKITEMGUID,
      };
      this.successMsg = 'Search term updated successfully';
      let PostTimeEntryData: any = {
        FormAction: 'update',
        VALIDATEONLY: true,
        Data: PostData,
      };
      this.timersService
        .setWorkItems(PostTimeEntryData)
        .pipe(takeUntil(this._unsubscribeAll$))
        .subscribe(
          (res) => {
            if (res.CODE == 200 && res.STATUS == 'success') {
              this.checkValidation(res.DATA.VALIDATIONS, PostTimeEntryData).then(() => {
                next('Done');
              });
            } else if (res.CODE == 451 && res.STATUS == 'warning') {
              this.checkValidation(res.DATA.VALIDATIONS, PostTimeEntryData).then(() => {
                next('Done');
              });
            } else if (res.CODE == 450 && res.STATUS == 'error') {
              this.checkValidation(res.DATA.VALIDATIONS, PostTimeEntryData).then(() => {
                next('Done');
              });
            } else if (res.MESSAGE == 'Not logged in') {
              this.dialogRef.close(false);
              next(true);
            }
          },
          (err) => {
            this.isspiner = false;
            this.toastr.error(err);
          },
        );
    });
  }

  /**
   * This function is used to check the validation.
   */
  checkValidation(bodyData: any, PostTimeEntryData: any) {
    let errorData: any = [];
    let warningData: any = [];
    let tempError: any = [];
    let tempWarning: any = [];
    return new Promise((next) => {
      // errorData
      bodyData.forEach(function (value) {
        if (value.VALUEVALID == 'NO' || value.VALUEVALID == 'No') {
          errorData.push(value.ERRORDESCRIPTION);
          tempError[value.FIELDNAME] = value;
        } else if (value.VALUEVALID == 'WARNING' || value.VALUEVALID == 'Warning') {
          tempWarning[value.FIELDNAME] = value;
          warningData.push(value.ERRORDESCRIPTION);
        }
      });

      this.errorWarningData = { Error: tempError, warning: tempWarning };
      if (Object.keys(errorData).length != 0) {
        this.toastr.error(errorData);
        this.isspiner = false;
      } else if (Object.keys(warningData).length != 0) {
        // this.toastr.warning(warningData);
        this.confirmDialogRef = this.MatDialog.open(FuseConfirmDialogComponent, {
          disableClose: true,
          width: DIALOG_WIDTH.FULL,
          data: warningData,
        });
        this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to Save?';
        this.confirmDialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.isspiner = true;
            this.saveTimeEntry(PostTimeEntryData).then(() => {
              this.confirmDialogRef = null;
              next(true);
            });
          }
          this.confirmDialogRef = null;
        });
      } else if (Object.keys(warningData).length == 0 && Object.keys(errorData).length == 0) {
        this.saveTimeEntry(PostTimeEntryData).then(() => {
          next(true);
        });
      }
    });
  }

  /**
   * This function is used to save the time entry
   */
  saveTimeEntry(PostTimeEntryData: any) {
    return new Promise((next, rej) => {
      PostTimeEntryData.VALIDATEONLY = false;
      this.timersService.setWorkItems(PostTimeEntryData).subscribe(
        (res) => {
          if (res.CODE == 200 && res.STATUS == 'success') {
            this.toastr.success(this.successMsg);
            this.behaviourService.setnextReCalcTimeEntrie('saveTimeEntry');
            next(true);
            // this.dialogRef.close(true);
            this.isspiner = false;
          } else if (res.CODE == 451 && res.STATUS == 'warning') {
            this.toastr.warning(res.MESSAGE);
            this.isspiner = false;
            next(true);
          } else if (res.CODE == 450 && res.STATUS == 'error') {
            this.toastr.warning(res.MESSAGE);
            this.isspiner = false;
            next(true);
          } else if (res.MESSAGE == 'Not logged in') {
            this.dialogRef.close(false);
            next(true);
          } else {
            next(true);
          }
        },
        (err) => {
          this.isspiner = false;
          this.toastr.error(err);
          next(true);
        },
      );
    });
  }

  /**
   * This function is used to load the Data value.
   */
  async loadData() {
    this.isLoadingResults = true;
    // let feData;
    let filterVal = JSON.parse(localStorage.getItem('wip_config'));
    // let filterDataVal = localStorage.getItem("FEEEARNERDATA");
    //  = JSON.parse(localStorage.getItem('set_active_matters'));
    const materIDofTab = window.name?.split('_');
    const windowNameId = materIDofTab?.[1];
    const currentKey = windowNameId || 'set_active_matters';
    let matterGuid = JSON.parse(localStorage.getItem(currentKey));

    if (!this.getSelectedWIP) {
      this.getSelectedWIP = matterGuid;
    }
    const timeEntryFE = JSON.parse(localStorage.getItem('timeEntriesFilter_config'));
    // feData = this.router.url == '/invoice/bulk-invoices' ? '' : (filterVal && filterVal.FEEEARNER) ? filterVal.FEEEARNER : this.FeeErner;
    let potData = {};
    if (this.router.url == '/invoice/bulk-invoices') {
      potData['INVOICING'] = true;
      potData['MATTERGUID'] = this.getSelectedWIP.MATTERGUID;
      potData['INVOICED'] = 'No';
    }
    if (
      this.router.url == '/matter-details/work-in-progress' ||
      this.router.url == '/client-details/work-in-progress'
    ) {
      potData['FEEEARNER'] = filterVal?.FEEEARNER;
      potData['SHOWDISBURSEMENTS'] = 0;
      potData['ITEMDATESTART'] = filterVal.ITEMDATESTART;
      potData['ITEMDATEEND'] = filterVal.ITEMDATEEND;
      potData['MATTERGUID'] = this.getSelectedWIP.MATTERGUID;
      potData['INVOICED'] = 'No';
    }

    if (
      this.router.url == '/time-entries/full-time-entries' ||
      this.router.url == '/time-entries/quick-time-entries'
    ) {
      potData['FEEEARNER'] = timeEntryFE?.FEEEARNER;
      potData['INVOICED'] = 'No';
      potData['SHOWDISBURSEMENTS'] = 0;
      potData['ITEMDATESTART'] = timeEntryFE.ITEMDATESTART;
      potData['ITEMDATEEND'] = timeEntryFE.ITEMDATEEND;
      potData['ITEMTYPE'] = timeEntryFE?.type;
      potData['GETALLDATA'] = false;
    }
    this._mainAPiServiceService
      .getSetData({ Action: 'GetData', Filters: potData }, 'workitem')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe(
        async (res) => {
          if (res.CODE == 200 && res.STATUS == 'success') {
            this.listofUnbuildtimeEntry = res.DATA.WORKITEMS;
          } else {
            this.listofUnbuildtimeEntry = [];
          }
          this.isLoadingResults = false;
        },
        (err) => {
          this.isLoadingResults = false;
          this.toastr.error(err);
        },
      );
  }

  checkUpdatedList() {
    if (!this.showStartCancel && this.searchTerm.trim()) {
      this.CheckTermToUnbilledTimeEntries();
    }
  }

  /**
   * This function is used to Check the TermToUNbilledTimeENTRIES
   */
  CheckTermToUnbilledTimeEntries() {
    if (this.searchTerm.trim() == '' || this.searchTerm.trim() == ' ') {
      this.toastr.error('Search Term is Required.');
      return;
    }

    // let filterData = this.listofUnbuildtimeEntry.filter((unbuildData) => {
    //   return unbuildData.ADDITIONALTEXT.toLowerCase() == this.searchTerm.toLowerCase() && (unbuildData.ITEMTYPEDESC == 'WIP' || unbuildData.ITEMTYPEDESC == 'Activity' || unbuildData.ITEMTYPEDESC == 'Sundry');
    // });
    // let pattern = this.searchTerm;
    // if (this.wholeWord) {
    //     pattern = `\\b${pattern}\\b`;
    // }
    // const flags = this.matchCase ? '' : 'i';
    // const regex = new RegExp(pattern, flags);
    // const regex = this.buildRegex(this.searchTerm.trim(), this.matchCase, this.wholeWord);
    // let filterData = this.listofUnbuildtimeEntry.filter((unbuildData) => {
    //     return unbuildData.ADDITIONALTEXT.trim().toLowerCase().indexOf(this.searchTerm.trim().toLowerCase()) > -1 && (unbuildData.ITEMTYPEDESC == 'WIP' || unbuildData.ITEMTYPEDESC == 'Activity' || unbuildData.ITEMTYPEDESC == 'Sundry');
    // });

    // let filterData = this.listofUnbuildtimeEntry.filter((unbuildData) => {
    //     const text = this.matchCase ? unbuildData.ADDITIONALTEXT.trim() : unbuildData.ADDITIONALTEXT.trim().toLowerCase();
    //     return regex.test(text) &&
    //       (unbuildData.ITEMTYPEDESC === 'WIP' ||
    //         unbuildData.ITEMTYPEDESC === 'Activity' ||
    //         unbuildData.ITEMTYPEDESC === 'Sundry');
    // });
    let filterData = cloneDeep(this.getFilteredData());
    if (filterData.length == 0) {
      this.toastr.error('There are no time entries/fixed fees available for search and replace!');
      return;
    }

    // this.CurrentAdditionalText=this.searchTerm;
    // this.UpdatedAdditionalext=this.replaceTerm;
    // let re = new RegExp(`\\b${this.searchTerm.trim().toLowerCase()}\\b`, 'gi');
    // let re = new RegExp(`${this.searchTerm.trim().toLowerCase()}`, 'gi');
    // let re = new RegExp(`${this.searchTerm.trim().toLowerCase()}`, 'gi');
    let re = this.buildRegex(this.searchTerm.trim(), this.matchCase, this.wholeWord);
    this.CurrentAdditionalText =
      filterData.length - 1 >= this.Apicount
        ? filterData[this.Apicount].ADDITIONALTEXT
        : this.UpdateDataValue();
    const str: string = filterData[this.Apicount].ADDITIONALTEXT;
    this.UpdatedAdditionalext =
      filterData.length - 1 >= this.Apicount
        ? str.replace(re, this.replaceTerm)
        : this.UpdateDataValue();
    this.readonly = true;
    this.isLoadingResults = true;
    this.isspiner = true;
    setTimeout(() => {
      this.showStartCancel = false;
      this.isLoadingResults = false;
      this.isspiner = false;
    }, 1000);
  }

  private buildRegex(term: string, matchCase: boolean, wholeWord: boolean): RegExp {
    // const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape special characters
    // const wordBoundaryTerm = wholeWord ? `\\b${escapedTerm}\\b` : escapedTerm;
    // const flags = matchCase ? 'g' : 'gi'; // g is always needed for replaceAll
    // return new RegExp(wordBoundaryTerm, flags);

    const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    const pattern = wholeWord ? `\\b${escapedTerm}\\b` : escapedTerm;

    return new RegExp(pattern, matchCase ? '' : 'i');
  }

  private getFilteredData(): any[] {
    // const regex = this.buildRegex(this.searchTerm.trim(), this.matchCase, this.wholeWord);
    // return this.listofUnbuildtimeEntry.filter((entry) => {
    //     const text = this.matchCase ? entry.ADDITIONALTEXT.trim() : entry.ADDITIONALTEXT.trim().toLowerCase();
    //     return regex.test(text) && ['WIP', 'Activity', 'Sundry'].includes(entry.ITEMTYPEDESC);
    // });

    const term = this.searchTerm?.trim();
    if (!term) return [];

    const regex = this.buildRegex(term, this.matchCase, this.wholeWord);
    return this.listofUnbuildtimeEntry.filter((entry) => {
      const text = entry.ADDITIONALTEXT || '';
      return regex.test(text) && ['WIP', 'Activity', 'Sundry'].includes(entry.ITEMTYPEDESC);
    });
  }
  /**
   * This function is used to update the Data value.
   */
  UpdateDataValue() {
    this.dialogRef.close(true);
    $('#refreshWorkInprogress').click();
    if (this.router.url == '/invoice/bulk-invoices') {
      $('#refreshtabledetails').click();
    }
  }
}
